module.exports = __webpack_public_path__ + "static/media/message04.0f9ffc2a.png";